module.exports = __webpack_public_path__ + "static/media/CB.e61cce40.jpg";